module.exports = __webpack_public_path__ + "img/send1.0437892e.svg";